import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import type { UserPrefs } from '@/types';


const DEFAULT_PREFS: UserPrefs = {
    language: 'en',
    city: 'Tampa',
    country: 'USA',
    state: 'Florida',
    viewMode: 'regular',
};


interface Ctx {
    prefs: UserPrefs;
    setPrefs: (p: UserPrefs) => void;
}


const UserPrefsContext = createContext<Ctx | undefined>(undefined);


export const UserPrefsProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
    const [prefs, setPrefs] = useState<UserPrefs>(() => {
        const raw = localStorage.getItem('userPrefs');
        return raw ? (JSON.parse(raw) as UserPrefs) : DEFAULT_PREFS;
    });


    useEffect(() => {
        localStorage.setItem('userPrefs', JSON.stringify(prefs));
    }, [prefs]);


    const value = useMemo(() => ({ prefs, setPrefs }), [prefs]);
    return <UserPrefsContext.Provider value={value}>{children}</UserPrefsContext.Provider>;
};


export function useUserPrefs() {
    const ctx = useContext(UserPrefsContext);
    if (!ctx) throw new Error('useUserPrefs must be used within UserPrefsProvider');
    return ctx;
}